import { Link } from "react-router-dom";
import PublicLayout from "../layout/Public";
import ResetForm from "../library/form/Reset";

function Reset(props) {
  return (
    <PublicLayout title="Reset Password | Aimex Australia App">
      <div className="text-center pb-4">
        <h1 className="text-4xl font-bold">Reset</h1>
        <div className="text-center pt-4">
          <p className="text-gray-600">
            Please provide your existing account email address to receive a new
            password
          </p>
        </div>
      </div>
      <ResetForm />
      <div className="text-center pt-6">
        <Link to="/login" className="text-secondary">
          Back to login
        </Link>
      </div>
    </PublicLayout>
  );
}

export default Reset;
